import Button from '../../UiElements/Button'
import React from 'react'
import { hasSectionShape } from '../forms/section2dFormItems'


export default function CallToAction(props?: any) {


	const form = props.formData

	const is2D = form?.profileView?.value === '2D'
	const sectionErrors = form.sections?.map((s: any) => s?.validations?.length || 0).reduce((a: number, b: number) => a + b, 0)
	const hasInvalid2DSection = is2D && form.sections?.some((section: any) =>
		!hasSectionShape(section?.formData)
	)

	const validationErrors = is2D
		? (!form.sections?.length || sectionErrors || hasInvalid2DSection || !form.priceModel || !form.name)
		: (!form?.glb || !form.sections?.length || sectionErrors || !form.priceModel || !form.name)

	const update = form.profileData?.id || form.id


	const handleValidateForm = async () => {
		const a = await props.validate?.()
		window.scrollTo(0, 0)
		console.log(a)
	}


	const handleCreateUpdateProduct = async () => {
		props.formData.callToAction?.(props.formData)
	}



	return (
		<div
			className={` border-gray-300 rounded-xl p-lg py-xl flex flex-col gap-xxl cursor-default select-none ${
				!validationErrors ? 'bg-primary-500' : 'bg-gray-300 hover:bg-gray-400 transition-all duration-300 '
			} text-white mt-xxl`}
		>
			<div className={' flex flex-col gap-xs'}>
				<span className={'text-title-xxl'}>{update ? 'Update' : 'Create'} Your Engraving Profile</span>

				{validationErrors ?
					<span className={'text-text-md flex flex-row gap-xs'}>

						Complete the
						<a
							onClick={handleValidateForm}
							className={"hover:underline underline cursor-pointer transition-all hover:text-red-500"}
						>
							required fields
						</a>
						to enable engraving.


					</span>
					:
					<span className={'text-text-md'}>Your engraving profile is ready. You can now make it available for engraving.</span>
				}
			</div>
			<Button
				size={'lg'}
				disabled={validationErrors}
				onClick={handleCreateUpdateProduct}
				type={'alt'}
				className={`w-[400px] border-0 ${update && !validationErrors ? 'hover:bg-primary-100' : ''}`}
			>
				{update ? 'Update Product Profile' : 'Create Product Profile'}
			</Button>
		</div>
	)
}
